import { el } from "../ui/dom";
import { icon } from "../ui/icons";
import type { ScreenContext } from "../shell/types";

// Every left-menu item opens a page with its mockup title. Until a module's own brief builds the
// screen, it shows an empty state; no module records exist yet.

/** The page head (mockup .head): eyebrow, a title with its icon, and an optional line under it. */
export function pageHead(
  ctx: Pick<ScreenContext, "section" | "screen">,
  line?: Node | string,
  actions: Node[] = [],
  eyebrow: string | null = ctx.section.brand,
): HTMLElement {
  return el(
    "div",
    { class: "head" },
    el(
      "div",
      { class: "t" },
      eyebrow ? el("div", { class: "eyebrow" }, eyebrow) : null,
      el("h1", {}, icon(ctx.screen.icon, "h1i"), ctx.screen.title),
      line ? el("div", { class: "muted" }, line) : null,
    ),
    el("div", { class: "actions" }, ...actions),
  );
}

export function emptyScreen(host: HTMLElement, ctx: ScreenContext) {
  host.append(
    pageHead(ctx),
    el(
      "div",
      { class: "blank" },
      icon(ctx.screen.icon, "big"),
      el("h2", {}, "Nothing here yet"),
      el("p", { class: "muted" }, `${ctx.screen.title} fills in as ${ctx.section.name} is built.`),
    ),
  );
}

/** A module that's off, an area set to None, or an address that isn't a screen. */
export function notAvailableScreen(host: HTMLElement, go: (path: string) => void) {
  const home = el("button", { type: "button", class: "btn pri" }, icon("home"), " Home");
  home.addEventListener("click", () => go("/"));
  host.append(
    el(
      "div",
      { class: "blank", role: "alert" },
      icon("circle-slash", "big"),
      el("h2", {}, "Not available"),
      el(
        "p",
        { class: "muted" },
        "This screen isn't on for the company, or the role doesn't include it.",
      ),
      home,
    ),
  );
}
